(() => {

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire292c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire292c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("imaXv", function(module, exports) {
function $8b92a9e94badc9da$var$main() {
    window.addEventListener('hashchange', (event)=>{
        const id = window.location.hash.slice(1);
        const prev = event.oldURL.includes('#') ? event.oldURL.split('#')[1] : '';
        if (prev == '' && id.length) console.log(`hope you enjoy your first article of the visit, "${$8b92a9e94badc9da$var$titleFromSlug(id)} :)"`);
        $8b92a9e94badc9da$var$expandArticle(id);
    });
    if (window.location.hash) {
        const id = window.location.hash.slice(1);
        $8b92a9e94badc9da$var$expandArticle(id);
    }
}
function $8b92a9e94badc9da$var$titleFromSlug(slug) {
    const elems = Array.from(document.querySelectorAll('article > h2')).filter((n)=>n.id.toLowerCase() === slug.toLowerCase());
    if (elems.length == 0) return '';
    if (elems.length > 1) console.log(`i have two articles with the same slug! i better fix that...`);
    if (elems[0].textContent == null) return '';
    return elems[0].textContent;
}
function $8b92a9e94badc9da$var$expandArticle(slug) {
    if (slug == '') return;
    const article = document.querySelector(`#${slug}`)?.parentElement?.parentElement;
    if (!article) return;
    article.classList.replace('collapsed', 'expanded');
    const a = article?.querySelector(`a.article-expander`);
    if (a) {
        a.text = '...enough';
        a.addEventListener('click', ()=>{
            $8b92a9e94badc9da$var$collapseArticle(article);
            a.addEventListener('click', ()=>{
                $8b92a9e94badc9da$var$expandArticle(slug);
            }, {
                once: true
            });
            return true;
        }, {
            once: true
        });
    }
}
function $8b92a9e94badc9da$var$collapseArticle(article) {
    article.classList.replace('expanded', 'collapsed');
    const a = article.querySelector(`a.article-expander`);
    if (a) a.text = 'more...';
}
(async ()=>{
    $8b92a9e94badc9da$var$main();
})();

});


parcelRequire("imaXv");
})();
//# sourceMappingURL=main.8dae5d1d.js.map
